import { render, staticRenderFns } from "./IconLEF.vue?vue&type=template&id=53a05911&"
import script from "./IconLEF.vue?vue&type=script&lang=ts&"
export * from "./IconLEF.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports